// extracted by mini-css-extract-plugin
export default {"component":"HL0eh"};